// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top{
    background-color: #17c7fc; margin-top: 80px; padding: 150px 0;
}
.bold-600{
    font-weight: 600;
    font-family: 'Montserrat';
}
.font-24{
    font-size: 28px;
    font-family: 'Montserrat';
}
.front{
    /* margin-top: 80px; */
     /* background-image: url(/assets/images/front/Rectangle.svg); */
     height: 275px;
    overflow: hidden;
}
.rate{
    position: absolute;
    width: 100%;
    top: 140px;
}

.copy{
    position: absolute;
    border-radius: 60px;
    padding: 12px 65px;
    font-size: 28px;
    font-weight: 800;
    height: 80px;
    cursor: pointer;
    background: #0070C0;
    text-align: center;
    color: white;
    width: 100%;
}
.block{
    background: #D9D9D9;

}
h6{
    margin: 0;
    font-weight: 500;
    color: #000;
}
h2{
    font-weight: 600;
    font-size: 20px;
    font-family: 'Montserrat';
    color: white;
}
.ic{
    padding: 48px 28px;
    background-color: #0070C0;
    min-height: 194px;
}
.btn-ic{
    background-color: #f38126;
    color: white;
    font-weight: 600;
    padding: 10px 60px;
    margin-top: 30px ;
}
.bottom{
    background: white;
    padding: 72px 0;
}
@media screen and (max-width:600px) {
    .top{
        display: none;
    }
    .front{
        margin-top: 30px;
        display: none;
        margin-bottom: 150px;
    }
    .rate{
        position: relative;
        top: 60px;
        margin-bottom: 24px;
    } 
    .copy{
        border-radius: 30px;
        /* padding: 12px 24px; */
        margin-top: 20px;
        margin-bottom: 40px;
        /* height: 60px; */
        font-size: 24px;
    }
    .border-right-1{
        border-bottom: 2px solid #707070;
    }
    .btn-login,.btn-sign,.btn p{
        width: 100%;
    }
    .mob-promo{
        background: #17c7fc;
    }
    .font-24,.bold-600{
        font-size: 16px; 
    }
    .bottom{
        display: none;
    }
}
@media screen and (max-width:380px) {
    .copy{
        padding: 12px 45px !important;
    }
}
@media screen and (max-width:344px) {
    .copy{
        padding: 12px 24px !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/studentDashboard/thank/thank.component.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB,EAAE,gBAAgB,EAAE,gBAAgB;AACjE;AACA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,sBAAsB;KACrB,+DAA+D;KAC/D,aAAa;IACd,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;AACA;IACI,mBAAmB;;AAEvB;AACA;IACI,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,gBAAgB;QAChB,aAAa;QACb,oBAAoB;IACxB;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,mBAAmB;IACvB;IACA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;IACnB;IACA;QACI,gCAAgC;IACpC;IACA;QACI,WAAW;IACf;IACA;QACI,mBAAmB;IACvB;IACA;QACI,eAAe;IACnB;IACA;QACI,aAAa;IACjB;AACJ;AACA;IACI;QACI,6BAA6B;IACjC;AACJ;AACA;IACI;QACI,6BAA6B;IACjC;AACJ","sourcesContent":[".top{\n    background-color: #17c7fc; margin-top: 80px; padding: 150px 0;\n}\n.bold-600{\n    font-weight: 600;\n    font-family: 'Montserrat';\n}\n.font-24{\n    font-size: 28px;\n    font-family: 'Montserrat';\n}\n.front{\n    /* margin-top: 80px; */\n     /* background-image: url(/assets/images/front/Rectangle.svg); */\n     height: 275px;\n    overflow: hidden;\n}\n.rate{\n    position: absolute;\n    width: 100%;\n    top: 140px;\n}\n\n.copy{\n    position: absolute;\n    border-radius: 60px;\n    padding: 12px 65px;\n    font-size: 28px;\n    font-weight: 800;\n    height: 80px;\n    cursor: pointer;\n    background: #0070C0;\n    text-align: center;\n    color: white;\n    width: 100%;\n}\n.block{\n    background: #D9D9D9;\n\n}\nh6{\n    margin: 0;\n    font-weight: 500;\n    color: #000;\n}\nh2{\n    font-weight: 600;\n    font-size: 20px;\n    font-family: 'Montserrat';\n    color: white;\n}\n.ic{\n    padding: 48px 28px;\n    background-color: #0070C0;\n    min-height: 194px;\n}\n.btn-ic{\n    background-color: #f38126;\n    color: white;\n    font-weight: 600;\n    padding: 10px 60px;\n    margin-top: 30px ;\n}\n.bottom{\n    background: white;\n    padding: 72px 0;\n}\n@media screen and (max-width:600px) {\n    .top{\n        display: none;\n    }\n    .front{\n        margin-top: 30px;\n        display: none;\n        margin-bottom: 150px;\n    }\n    .rate{\n        position: relative;\n        top: 60px;\n        margin-bottom: 24px;\n    } \n    .copy{\n        border-radius: 30px;\n        /* padding: 12px 24px; */\n        margin-top: 20px;\n        margin-bottom: 40px;\n        /* height: 60px; */\n        font-size: 24px;\n    }\n    .border-right-1{\n        border-bottom: 2px solid #707070;\n    }\n    .btn-login,.btn-sign,.btn p{\n        width: 100%;\n    }\n    .mob-promo{\n        background: #17c7fc;\n    }\n    .font-24,.bold-600{\n        font-size: 16px; \n    }\n    .bottom{\n        display: none;\n    }\n}\n@media screen and (max-width:380px) {\n    .copy{\n        padding: 12px 45px !important;\n    }\n}\n@media screen and (max-width:344px) {\n    .copy{\n        padding: 12px 24px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
